import React from 'react';
import { Link } from 'react-router-dom';

function Navbar({ theme, setTheme }) {
  const handleThemeChange = (theme) => {
    setTheme(theme);
    const root = window.document.documentElement;

    if (theme === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
    } else if (theme === 'light') {
      root.classList.add('light');
      root.classList.remove('dark');
    } else {
      // For system, we'll remove both dark and light, so it follows system preferences
      root.classList.remove('dark');
      root.classList.remove('light');
    }
  };

  return (
    <div className="container mx-auto flex justify-between items-center">
      <nav className="text-white dark:bg-gray-800 p-4 dark:text-white flex justify-between">
        <div className="ml-10 flex items-baseline space-x-4">
          <Link to="/" className="text-white hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md font-bold text-lg">
            Scoreboarding
          </Link>
          <Link to="/team" className="text-white hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md font-bold text-lg whitespace-nowrap">
            Team Management
          </Link>
          <Link to="/about" className="text-white hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md font-bold text-lg">
            Intro
          </Link>
        </div>
      </nav>
      <img src="img/isologotipo.png" alt="Tu imagen" className="h-28 rounded-full" />
    </div>
  );
}

export default Navbar;